module.exports = __webpack_public_path__ + "logo.svg?aaf117aa9eeb0616b7e8dd188110e267";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.svg
// module id = 15
// module chunks = 0